//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RevisionClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchRevisionQueryParameters = {
  projectId?: number | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type CopyFromProjectRevisionQueryParameters = {
  id?: number | undefined ;
  projectId?: number | undefined ;
}

export type PatchRevisionQueryParameters = {
  id: number ;
}

export type GetRevisionQueryParameters = {
  id: number ;
}

export type ExportToSharePointRevisionQueryParameters = {
  id: number ;
}

export type ImportFromSharepointRevisionQueryParameters = {
  id: number ;
  sharepointUrl?: string | undefined ;
}

export type ImportFromEntriesRevisionQueryParameters = {
  id: number ;
}

export type UpdateVariablesRevisionQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/revisions";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.RevisionDto, unknown, Types.CreateRevisionDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RevisionDto, unknown, Types.CreateRevisionDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateRevisionDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function searchUrl(projectId?: number | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/revisions?";
if (projectId === null)
    throw new Error("The parameter 'projectId' cannot be null.");
else if (projectId !== undefined)
    url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfRevisionListItemDto, unknown, Types.PagedResultOfRevisionListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfRevisionListItemDto, unknown, Types.PagedResultOfRevisionListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchRevisionQueryParameters): QueryKey;
export function searchQueryKey(projectId?: number | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { projectId, offset, limit, sortBy, sortOrder,  } = params[0] as SearchRevisionQueryParameters;

    return trimArrayEnd([
        'RevisionClient',
        'search',
        projectId as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'RevisionClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfRevisionListItemDto, TError = unknown>(dto: SearchRevisionQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfRevisionListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfRevisionListItemDto, TError = unknown>(projectId?: number | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfRevisionListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfRevisionListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfRevisionListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let projectId: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ projectId, offset, limit, sortBy, sortOrder,  } = params[0] as SearchRevisionQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [projectId, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfRevisionListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(projectId, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfRevisionListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfRevisionListItemDto | undefined) => Types.PagedResultOfRevisionListItemDto, projectId?: number | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(projectId, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfRevisionListItemDto | undefined) => Types.PagedResultOfRevisionListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function copyFromProjectUrl(id?: number | undefined, projectId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/revisions/copy?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
if (projectId === null)
    throw new Error("The parameter 'projectId' cannot be null.");
else if (projectId !== undefined)
    url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function copyFromProjectMutationKey(id?: number | undefined, projectId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'copyFromProject',
      id as any,
      projectId as any,
    ]);
}

export function useCopyFromProjectMutation<TContext>(id?: number | undefined, projectId?: number | undefined, options?: Omit<UseMutationOptions<Types.RevisionDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RevisionDto, unknown, void, TContext> {
  const key = copyFromProjectMutationKey(id, projectId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.copyFromProject(id, projectId),
    mutationKey: key,
  });
}
  
type CopyFromProject__MutationParameters = CopyFromProjectRevisionQueryParameters

export function useCopyFromProjectMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RevisionDto, unknown, CopyFromProject__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CopyFromProjectRevisionQueryParameters}): UseMutationResult<Types.RevisionDto, unknown, CopyFromProject__MutationParameters, TContext> {
  const key = copyFromProjectMutationKey(options?.parameters?.id!, options?.parameters?.projectId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CopyFromProject__MutationParameters) => Client.copyFromProject(data.id ?? options?.parameters?.id!, data.projectId ?? options?.parameters?.projectId!),
  mutationKey: key,
});
}
  
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.RevisionDto, unknown, Types.PatchRevisionDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RevisionDto, unknown, Types.PatchRevisionDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchRevisionDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchRevisionQueryParameters & {
  dto: Types.PatchRevisionDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RevisionDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchRevisionQueryParameters}): UseMutationResult<Types.RevisionDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.RevisionDto, unknown, Types.RevisionDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RevisionDto, unknown, Types.RevisionDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetRevisionQueryParameters;

    return trimArrayEnd([
        'RevisionClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'RevisionClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.RevisionDto, TError = unknown>(dto: GetRevisionQueryParameters, options?: Omit<UseQueryOptions<Types.RevisionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.RevisionDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.RevisionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.RevisionDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RevisionDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetRevisionQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RevisionDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.RevisionDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.RevisionDto | undefined) => Types.RevisionDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RevisionDto | undefined) => Types.RevisionDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function exportToSharePointUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}/export-sharepoint";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function exportToSharePointMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'exportToSharePoint',
      id as any,
    ]);
}

export function useExportToSharePointMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = exportToSharePointMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.exportToSharePoint(id),
    mutationKey: key,
  });
}
  
type ExportToSharePoint__MutationParameters = ExportToSharePointRevisionQueryParameters

export function useExportToSharePointMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ExportToSharePoint__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExportToSharePointRevisionQueryParameters}): UseMutationResult<void, unknown, ExportToSharePoint__MutationParameters, TContext> {
  const key = exportToSharePointMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExportToSharePoint__MutationParameters) => Client.exportToSharePoint(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function importFromSharepointUrl(id: number, sharepointUrl?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}/import-sharepoint?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sharepointUrl === null)
    throw new Error("The parameter 'sharepointUrl' cannot be null.");
else if (sharepointUrl !== undefined)
    url_ += "sharepointUrl=" + encodeURIComponent("" + sharepointUrl) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function importFromSharepointMutationKey(id: number, sharepointUrl?: string | undefined): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'importFromSharepoint',
      id as any,
      sharepointUrl as any,
    ]);
}

export function useImportFromSharepointMutation<TContext>(id: number, sharepointUrl?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = importFromSharepointMutationKey(id, sharepointUrl);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.importFromSharepoint(id, sharepointUrl),
    mutationKey: key,
  });
}
  
type ImportFromSharepoint__MutationParameters = ImportFromSharepointRevisionQueryParameters

export function useImportFromSharepointMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ImportFromSharepoint__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ImportFromSharepointRevisionQueryParameters}): UseMutationResult<void, unknown, ImportFromSharepoint__MutationParameters, TContext> {
  const key = importFromSharepointMutationKey(options?.parameters?.id!, options?.parameters?.sharepointUrl!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ImportFromSharepoint__MutationParameters) => Client.importFromSharepoint(data.id ?? options?.parameters?.id!, data.sharepointUrl ?? options?.parameters?.sharepointUrl!),
  mutationKey: key,
});
}
  
export function importFromEntriesUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}/import-entries";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function importFromEntriesMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'importFromEntries',
      id as any,
    ]);
}

export function useImportFromEntriesMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.SelectionEntryDto[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SelectionEntryDto[], TContext> {
  const key = importFromEntriesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (entries: Types.SelectionEntryDto[]) => Client.importFromEntries(id, entries),
    mutationKey: key,
  });
}
  
type ImportFromEntries__MutationParameters = ImportFromEntriesRevisionQueryParameters & {
  entries: Types.SelectionEntryDto[];
}

export function useImportFromEntriesMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ImportFromEntries__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ImportFromEntriesRevisionQueryParameters}): UseMutationResult<void, unknown, ImportFromEntries__MutationParameters, TContext> {
  const key = importFromEntriesMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ImportFromEntries__MutationParameters) => Client.importFromEntries(data.id ?? options?.parameters?.id!, data.entries),
  mutationKey: key,
});
}
  
export function updateVariablesUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/revisions/{id}/update-variables";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateVariablesMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RevisionClient',
      'updateVariables',
      id as any,
    ]);
}

export function useUpdateVariablesMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, number[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, number[], TContext> {
  const key = updateVariablesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (variables: number[]) => Client.updateVariables(id, variables),
    mutationKey: key,
  });
}
  
type UpdateVariables__MutationParameters = UpdateVariablesRevisionQueryParameters & {
  variables: number[];
}

export function useUpdateVariablesMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UpdateVariables__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateVariablesRevisionQueryParameters}): UseMutationResult<void, unknown, UpdateVariables__MutationParameters, TContext> {
  const key = updateVariablesMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateVariables__MutationParameters) => Client.updateVariables(data.id ?? options?.parameters?.id!, data.variables),
  mutationKey: key,
});
}